import * as React from 'react';

//tslint:disable-next-line:no-any
function BankCardsIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={53.322} height={53.321} viewBox="0 0 53.322 53.321" {...props}>
      <defs>
        <style>{'.prefix__a{fill:#0102ce}'}</style>
      </defs>
      <path
        className="prefix__a"
        // tslint:disable-next-line:max-line-length
        d="M35.302 1.065a3.653 3.653 0 00-5.157 0L12.241 18.954h11.773L38.602 4.362zM52.253 17.995L40.819 6.57 28.433 18.953h12.7a6.777 6.777 0 016.769 6.769v1.77l4.347-4.342a3.643 3.643 0 000-5.156zM28.342 41.226a2.083 2.083 0 100 2.946 2.076 2.076 0 000-2.946zM35.632 41.226a2.083 2.083 0 100 2.946 2.076 2.076 0 000-2.946z"
      />
      <path
        className="prefix__a"
        // tslint:disable-next-line:max-line-length
        d="M41.137 22.082H3.645A3.649 3.649 0 000 25.723v23.953a3.649 3.649 0 003.645 3.645h37.492a3.649 3.649 0 003.645-3.645V25.723a3.649 3.649 0 00-3.645-3.641zM30.2 30.41h8.332v3.124H30.2zm-23.016 0h18.54v3.124H7.186zm30.657 15.972a5.212 5.212 0 01-7.327.035 5.207 5.207 0 110-7.435 5.213 5.213 0 017.327.035 5.213 5.213 0 010 7.365z"
      />
    </svg>
  );
}

export default BankCardsIcon;
